"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var debounce = require("lodash.debounce");
var react_hotkeys_1 = require("react-hotkeys");
var __exports_1 = require("../__exports");
var Predictions_1 = require("./Predictions");
var utils_1 = require("./utils");
require("./PredictiveSearch.css");
var PredictiveSearch = /** @class */ (function (_super) {
    __extends(PredictiveSearch, _super);
    function PredictiveSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.isIE11 = utils_1.isIE11();
        _this._id = props.id ? props.id : "PredictiveSearch-" + __exports_1.createUUID();
        _this._predictionsId = _this._id + "_Predictions";
        _this._clickHandler = _this._clickHandler.bind(_this);
        _this._onBlur = _this._onBlur.bind(_this);
        _this._onFocus = _this._onFocus.bind(_this);
        _this._onChange = _this._onChange.bind(_this);
        _this._onPredictDebounced = debounce(_this._onPredictDebounced.bind(_this), props.debounceWait, {
            maxWait: props.debounceMaxWait
        });
        _this._onSelect = _this._onSelect.bind(_this);
        _this._onSearch = _this._onSearch.bind(_this);
        _this._closePredictions = _this._closePredictions.bind(_this);
        _this._keyEnter = _this._keyEnter.bind(_this);
        _this._keyUp = _this._keyUp.bind(_this);
        _this._keyDown = _this._keyDown.bind(_this);
        _this._clickPrediction = _this._clickPrediction.bind(_this);
        _this._setPredictionsPosition = _this._setPredictionsPosition.bind(_this);
        _this._getPredictorProps = _this._getPredictorProps.bind(_this);
        _this._getOuterCSS = _this._getOuterCSS.bind(_this);
        _this._getHotKeysProps = _this._getHotKeysProps.bind(_this);
        _this._generateItemId = _this._generateItemId.bind(_this);
        _this._renderPredictions = _this._renderPredictions.bind(_this);
        _this._resizeHandler = debounce(_this._resizeHandler.bind(_this), 50);
        _this.state = {
            predictions: [],
            predictionsIsOpen: false,
            predictionsPosition: {
                top: null,
                left: null
            },
            value: props.value || '',
            currentQuery: props.value || '',
            focusedPrediction: -1,
            calculatedWidth: null
        };
        return _this;
    }
    /* istanbul ignore next */
    PredictiveSearch.prototype.componentDidMount = function () {
        window.addEventListener('click', this._clickHandler);
        window.addEventListener('resize', this._resizeHandler);
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this._clickHandler);
        window.removeEventListener('resize', this._resizeHandler);
    };
    PredictiveSearch.prototype.componentWillReceiveProps = function (nextProps) {
        var nextPredictions = nextProps.predictions;
        var nextValue = nextProps.value;
        var _a = this.props, value = _a.value, predictions = _a.predictions;
        // Note: React v15 only, issue is fixed on React v16
        // on IE11, onChange event might come after actual value of an element
        // have changed. We detect this and render element as-is.
        // Ignoring this causes skipped letters in controlled components
        if (this.isIE11) {
            nextValue = this._refPredictor.value;
        }
        if (typeof nextValue === 'string' && nextValue !== value) {
            this.setState({
                value: nextValue
            });
        }
        if ((nextPredictions !== undefined && nextPredictions !== predictions) || nextPredictions === null) {
            this.setState({
                predictions: nextPredictions
            });
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._clickHandler = function (e) {
        var _a = this, _id = _a._id, _closePredictions = _a._closePredictions;
        var target = e.target;
        var id = new RegExp("(" + _id + ")");
        var classes = new RegExp(/(predictor|prediction|predictions)/);
        if (!target.id.match(id) || !target.className.match(classes)) {
            _closePredictions();
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._resizeHandler = function () {
        // Repositions predictions
        if (this._refPredictor && this._refPredictions) {
            // Note: Width needs to be updated first prior to resetting the position.
            // This takes care of the case where after the orientation switch from
            // landscape to portrait on smaller devices, the portal decides to render
            // it to the far left of the screen.
            this.setState({
                calculatedWidth: this._refPredictor.getBoundingClientRect().width
            }, this._setPredictionsPosition);
        }
    };
    PredictiveSearch.prototype._onBlur = function (e) {
        var value = e.target.value;
        var _id = this._id;
        var onBlur = this.props.onBlur;
        if (onBlur) {
            onBlur(_id, value);
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._onFocus = function (e) {
        var value = e.target.value;
        var onFocus = this.props.onFocus;
        if (onFocus) {
            onFocus(this._id, value);
        }
        this.setState({
            predictionsIsOpen: true
        });
    };
    PredictiveSearch.prototype._onChange = function (e) {
        var target = e.target;
        var value = target.value;
        var _a = this, _id = _a._id, _refPredictor = _a._refPredictor, _onPredictDebounced = _a._onPredictDebounced, onChange = _a.props.onChange;
        /* istanbul ignore next */
        var calculatedWidth = _refPredictor && _refPredictor.getBoundingClientRect().width;
        this.setState({
            predictionsIsOpen: true,
            focusedPrediction: -1,
            value: value,
            currentQuery: value,
            calculatedWidth: calculatedWidth
        }, function () {
            onChange && onChange(_id, value);
            _onPredictDebounced();
        });
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._onPredictDebounced = function () {
        var _a = this, _id = _a._id, _b = _a.props, onPredict = _b.onPredict, minPredictLength = _b.minPredictLength, currentQuery = _a.state.currentQuery;
        if (!minPredictLength || (currentQuery && currentQuery.length >= minPredictLength)) {
            onPredict && onPredict(_id, currentQuery);
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._onSelect = function (prediction) {
        var _a = this, _id = _a._id, _closePredictions = _a._closePredictions, onSelect = _a.props.onSelect;
        if (prediction.hasOwnProperty('url')) {
            window.location.href = prediction.url || '';
        }
        else {
            onSelect && onSelect(_id, prediction);
        }
        _closePredictions();
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._onSearch = function () {
        var _a = this, _id = _a._id, _closePredictions = _a._closePredictions, _b = _a.props, searchResultsPage = _b.searchResultsPage, onSearch = _b.onSearch, value = _a.state.value;
        if (searchResultsPage && !onSearch) {
            window.location.href = searchResultsPage.replace('${q}', encodeURIComponent(value));
        }
        else {
            onSearch && onSearch(_id, value);
        }
        _closePredictions();
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._closePredictions = function () {
        this.setState({
            predictionsPosition: {
                top: null,
                left: null
            },
            predictionsIsOpen: false,
            focusedPrediction: -1
        });
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._keyEnter = function (prediction) {
        var _a = this, _onSearch = _a._onSearch, _onSelect = _a._onSelect, focusedPrediction = _a.state.focusedPrediction;
        focusedPrediction !== -1 && prediction ? _onSelect(prediction) : _onSearch();
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._keyUp = function (previousPrediction) {
        var _a = this.state, predictions = _a.predictions, focusedPrediction = _a.focusedPrediction, currentQuery = _a.currentQuery;
        if (predictions && focusedPrediction && focusedPrediction > -1) {
            this.setState({
                focusedPrediction: previousPrediction,
                value: predictions[previousPrediction] ? predictions[previousPrediction].text : currentQuery
            });
        }
        else if (predictions && predictions.length > 0) {
            this.setState({
                focusedPrediction: predictions.length - 1,
                value: predictions[predictions.length - 1].text
            });
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._keyDown = function (nextPrediction) {
        var _a = this.state, predictions = _a.predictions, focusedPrediction = _a.focusedPrediction, currentQuery = _a.currentQuery;
        if (predictions && focusedPrediction < predictions.length - 1) {
            this.setState({
                focusedPrediction: nextPrediction,
                value: predictions[nextPrediction].text
            });
        }
        else {
            this.setState({
                focusedPrediction: -1,
                value: currentQuery
            });
        }
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._clickPrediction = function (focusedPrediction, value) {
        var changeQueryToSelectedOnSelect = this.props.changeQueryToSelectedOnSelect;
        var _a = this, _onSelect = _a._onSelect, predictions = _a.state.predictions;
        var nextState = changeQueryToSelectedOnSelect
            ? {
                focusedPrediction: focusedPrediction,
                value: value
            }
            : {
                focusedPrediction: focusedPrediction
            };
        this.setState(nextState, function () {
            predictions && _onSelect(predictions[focusedPrediction]);
        });
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._setPredictionsPosition = function () {
        var _a = this, _refPredictions = _a._refPredictions, _refPredictor = _a._refPredictor;
        var predictionsPosition = __exports_1.positionDropdown(_refPredictions._refPredictionsInner, _refPredictor, document.body);
        this.setState({ predictionsPosition: predictionsPosition });
        return {};
    };
    PredictiveSearch.prototype._getPredictorProps = function () {
        var _this = this;
        var _a = this, _id = _a._id, _onBlur = _a._onBlur, _onFocus = _a._onFocus, _onChange = _a._onChange, _predictionsId = _a._predictionsId, _b = _a.props, placeholder = _b.placeholder, maxLength = _b.maxLength, errorMessage = _b.errorMessage, isEnabled = _b.isEnabled, ariaLabel = _b.ariaLabel, ariaLabelledBy = _b.ariaLabelledBy, _c = _a.state, value = _c.value, predictionsIsOpen = _c.predictionsIsOpen, focusedPrediction = _c.focusedPrediction;
        var cssPredictor = ['predictor', 'p-f-w-6', 'p-bg-hv-grey70', 'p-bc-f-primary50', 'p-ph-grey50'];
        if (errorMessage) {
            cssPredictor.push('p-b-error', 'p-bc-error50');
        }
        return {
            ref: function (r) {
                _this._refPredictor = r;
            },
            id: _id,
            className: cssPredictor.join(' '),
            value: value,
            onBlur: _onBlur,
            onFocus: _onFocus,
            onChange: _onChange,
            disabled: !isEnabled,
            placeholder: placeholder || undefined,
            maxLength: maxLength || undefined,
            type: 'text',
            autoComplete: 'off',
            role: 'combobox',
            'aria-label': ariaLabel || undefined,
            'aria-labelledby': ariaLabelledBy || undefined,
            'aria-invalid': !!errorMessage,
            'aria-disabled': !isEnabled,
            'aria-autocomplete': 'list',
            'aria-expanded': predictionsIsOpen,
            'aria-haspopup': predictionsIsOpen,
            'aria-owns': "" + _predictionsId,
            'aria-activedescendant': focusedPrediction > -1 ? _predictionsId + "--" + focusedPrediction : undefined
        };
    };
    PredictiveSearch.prototype._getOuterCSS = function () {
        var _a = this.props, errorMessage = _a.errorMessage, isEnabled = _a.isEnabled;
        var outerCSS = ['p-predictivesearch', 'form-row'];
        if (!isEnabled) {
            outerCSS.push('is-disabled');
        }
        if (errorMessage) {
            outerCSS.push('is-invalid');
        }
        return outerCSS.join(' ');
    };
    /* istanbul ignore next */
    PredictiveSearch.prototype._getHotKeysProps = function () {
        var _a = this, _closePredictions = _a._closePredictions, _keyEnter = _a._keyEnter, _keyUp = _a._keyUp, _keyDown = _a._keyDown, _b = _a.state, predictions = _b.predictions, predictionsIsOpen = _b.predictionsIsOpen, focusedPrediction = _b.focusedPrediction;
        return {
            keyMap: {
                keyEsc: ['tab', 'shift+tab', 'esc'],
                keyEnter: 'enter',
                keyUp: 'up',
                keyDown: 'down'
            },
            handlers: {
                keyEsc: function () {
                    _closePredictions();
                },
                keyEnter: function (e) {
                    e.preventDefault();
                    var prediction = predictions && predictions[focusedPrediction];
                    _keyEnter(prediction);
                },
                keyUp: function (e) {
                    if (predictionsIsOpen && predictions && predictions.length) {
                        focusedPrediction !== -1 && e.preventDefault();
                        _keyUp(focusedPrediction - 1);
                    }
                },
                keyDown: function (e) {
                    if (predictionsIsOpen && predictions && predictions.length) {
                        focusedPrediction !== -1 && e.preventDefault();
                        _keyDown(focusedPrediction + 1);
                    }
                }
            }
        };
    };
    PredictiveSearch.prototype._generateItemId = function (predictions, predictionsId) {
        return predictions.map(function (item, index) {
            item['itemId'] = predictionsId + "--" + index;
            return item;
        });
    };
    PredictiveSearch.prototype._renderPredictions = function (Predictions) {
        var _this = this;
        var _a = this, _predictionsId = _a._predictionsId, _clickPrediction = _a._clickPrediction, _generateItemId = _a._generateItemId, noPredictionsMessage = _a.props.noPredictionsMessage, _b = _a.state, predictions = _b.predictions, predictionsPosition = _b.predictionsPosition, predictionsIsOpen = _b.predictionsIsOpen, focusedPrediction = _b.focusedPrediction, calculatedWidth = _b.calculatedWidth;
        var predictionsWithItemIds = predictions && _generateItemId(predictions, _predictionsId);
        return (React.createElement(Predictions, { ref: 
            /* istanbul ignore next */ function (r) {
                _this._refPredictions = r;
            }, id: "" + _predictionsId, width: calculatedWidth, predictions: predictionsWithItemIds, focusedPrediction: focusedPrediction, coordinates: predictionsPosition, onClick: _clickPrediction, noPredictionsMessage: noPredictionsMessage, predictionsIsOpen: predictionsIsOpen }));
    };
    PredictiveSearch.prototype.render = function () {
        var _a = this, _getOuterCSS = _a._getOuterCSS, _getHotKeysProps = _a._getHotKeysProps, _getPredictorProps = _a._getPredictorProps, _setPredictionsPosition = _a._setPredictionsPosition, _renderPredictions = _a._renderPredictions, _b = _a.props, errorMessage = _b.errorMessage, iconName = _b.iconName, isLoading = _b.isLoading, tag = _b.tag, predictionsComponent = _b.predictionsComponent, _c = _a.state, value = _c.value, predictionsIsOpen = _c.predictionsIsOpen;
        var iconOrSpinner = isLoading ? 'predictive-spinner' : "p-icon-" + iconName;
        return (React.createElement("div", { className: _getOuterCSS(), "data-tag": tag },
            React.createElement(react_hotkeys_1.HotKeys, __assign({}, _getHotKeysProps()),
                React.createElement("i", { className: "predictor-icon " + iconOrSpinner }),
                React.createElement("input", __assign({}, _getPredictorProps())),
                errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage),
                React.createElement(__exports_1.Portal, { isOpened: predictionsIsOpen && value !== '', onOpen: _setPredictionsPosition }, _renderPredictions((predictionsComponent || Predictions_1.default))))));
    };
    PredictiveSearch.defaultProps = {
        id: null,
        value: '',
        placeholder: null,
        minPredictLength: 2,
        maxLength: null,
        errorMessage: null,
        isEnabled: true,
        ariaLabel: null,
        ariaLabelledBy: null,
        isLoading: false,
        predictions: null,
        noPredictionsMessage: null,
        searchResultsPage: null,
        debounceWait: 500,
        debounceMaxWait: 3000,
        iconName: 'magnifying-glass',
        tag: null,
        predictionsComponent: null,
        changeQueryToSelectedOnSelect: true
    };
    return PredictiveSearch;
}(React.Component));
exports.PredictiveSearch = PredictiveSearch;
exports.default = PredictiveSearch;
//# sourceMappingURL=PredictiveSearch.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/predictive-search/build/control/PredictiveSearch.js
// module id = 570
// module chunks = 0